import LoaderPage from '@/shared/components/loaders/LoaderPage';
import { Suspense } from 'react';
import { type RouteObject, createBrowserRouter } from 'react-router-dom';
import PrivateErrorLayout from '../layouts/PrivateErrorLayout';
import PrivateLayout from '../layouts/PrivateLayout';
import PublicLayout from '../layouts/PublicLayout';
import { privateRoutes } from './PrivateRoutes';
import { publicRoutes } from './PublicRoutes';

/**
 * Configuración principal del enrutador de la aplicación
 * Define dos grupos de rutas:
 * - Rutas públicas: /login con PublicLayout
 * - Rutas privadas: /* con PrivateLayout y manejo de errores
 *
 * Todas las rutas utilizan Suspense con LoaderPage como fallback
 * para manejar lazy loading de componentes
 *
 * @constant {ReturnType<typeof createBrowserRouter>} router - Instancia del router de React Router
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <Suspense fallback={<LoaderPage />}>
        <PublicLayout />
      </Suspense>
    ),
    children: publicRoutes,
  },
  {
    path: '/',
    element: (
      <Suspense fallback={<LoaderPage />}>
        <PrivateLayout />
      </Suspense>
    ),
    errorElement: <PrivateErrorLayout />,
    children: privateRoutes as RouteObject[],
  },
]);
